import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GeographicalMapDataService } from './data-access/geographical-map-data.service';
import { EicD3MapComponent } from './feature/eic-d3-map/eic-d3-map.component';
import { MapLegendComponent } from './ui/map-legend/map-legend.component';

@NgModule({
  declarations: [
    EicD3MapComponent,
    MapLegendComponent
  ],
  imports: [CommonModule],
  providers: [GeographicalMapDataService],
  exports: [
    EicD3MapComponent,
    MapLegendComponent
  ]
})
export class GeographicalMapModule {}
